import React, { forwardRef } from 'react';
import './Textfield.css';
import Icon from '../home/Icon';

function Textfield({ placeholder = "", type = "", required = false, name = "", icon = "", fill = false, onChange = () => {}, value = "", label = "", ...rest }, ref) {
  const input = (
    <div className={`textFieldContainer ${icon ? 'withIcon' : 'withoutIcon'}`}>
      {icon && (
        <div className={"textFieldIconContainer"}>
          <Icon className={`textFieldIcon ${fill ? "filled" : "notfilled"}`} icon={icon} />
        </div>
      )}
      <input ref={ref} type={type} required={required} name={name} placeholder={placeholder} onChange={onChange} value={value} {...rest} />
    </div>
  );

  if (label) {
    return (
      <div className="textFieldWrapper">
        <label className="textFieldLabel">{label}</label>
        {input}
      </div>
    );
  }
  return input;
}

export default forwardRef(Textfield)